<app-janela [idModal]="idModal" [titulo]="titulo">
  <span *ngFor="let item of lista">
    <span class="btn btn-primary btn-sm itemListaSelecao" data-toggle="tooltip" [attr.title]="item.toDescricao()"
      style="font-size: 14px; margin: 2px;" (click)="escolher(item)">{{item.toTexto()}}&nbsp;
      <em class="fa fa-plus"></em>
    </span>
  </span>
</app-janela>
